import {IIBuildContent} from '@/utils/interfaces/bloks';
import {render} from 'storyblok-rich-text-react-renderer';
import {CTA} from "@/components/Shared/CTA/CallToAction";
import {CtaContainer} from "@/components/Shared/CTA/CtaContainer";
import {isArrayWithValue} from "@/utils/helpers/isArrayWithValue";
import { Container } from '../Shared/Layout/Container';
import { FormattedText } from '../Shared/FormattedText';

interface IProps {
    blok: IIBuildContent;
}

export const CenterContent: React.FC<IProps> = ({blok}) => {
    return (
        <Container className='mb-14 mt-10 max-w-4xl' align="center">
            <FormattedText
                tag="h2"
                text={render(blok.content)}
                className="text-inherit"
            />
        </Container>
    );
};
